import { Link } from "react-router-dom"


const Errors=()=>{

    return <><h1>404 Not Found</h1><Link to='/'><button>Home</button></Link></>
}

export default Errors;